import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import PhoneLink from 'components/common/PhoneLink'
import { A } from 'components/common/Link/Link'
import Text from 'components/common/Text/Text'
import Icon from 'components/common/Icon/Icon'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'

const MyStoreBar = ({
  address,
  formattedNumber,
  showStoreLocatorModalInAppointmentMode,
  setShowStoreDetails,
  nullState
}) =>
  <Wrapper>
    <Media.Desktop>
      <MyStoreHeadingWrapper>
        <Circle nullState={ nullState }>
          <CheckIcon asset="check-white" />
        </Circle>
        <MyStoreHeading nullState={ nullState }>
          {
            nullState ?
              'No Store Selected' :
              'My Store'
          }
        </MyStoreHeading>
      </MyStoreHeadingWrapper>
      <AddressWrapper>{ address }</AddressWrapper>
      {formattedNumber && (
        <StyledText>
          <PhoneIcon asset="phone-black" height={ 13 } width={ 13 } />
          { formattedNumber }
        </StyledText>
      )}
      <StoreDetailsWrapper nullState={ nullState }>
        {
          !nullState ?
            <Fragment>
              <StoreDetailsLink prevent handler={ () => setShowStoreDetails(true) }>Store Details</StoreDetailsLink>
              <ChangeStoreLink prevent handler={ () => showStoreLocatorModalInAppointmentMode() }>
                Change Store
              </ChangeStoreLink>
            </Fragment> :
            <ChangeStoreLink prevent handler={ () => showStoreLocatorModalInAppointmentMode() }>
              Select Store
            </ChangeStoreLink>
        }
      </StoreDetailsWrapper>
    </Media.Desktop>
    <Media.Mobile>
      <MyStoreHeadingWrapper>
        <Circle nullState={ nullState }>
          <CheckIcon asset="check-white" />
        </Circle>
        <MyStoreHeading nullState={ nullState }>
          {
            nullState ?
              'No Store Selected' :
              'My Store'
          }
        </MyStoreHeading>
      </MyStoreHeadingWrapper>
      <StoreDetailsWrapper nullState={ nullState }>
        {
          !nullState ?
            <Fragment>
              <StoreDetailsLink prevent handler={ () => setShowStoreDetails(true) }>Store Details</StoreDetailsLink>
              <ChangeStoreLink prevent handler={ () => showStoreLocatorModalInAppointmentMode() }>
                Change Store
              </ChangeStoreLink>
            </Fragment> :
            <ChangeStoreLink prevent handler={ () => showStoreLocatorModalInAppointmentMode() }>
              Select Store
            </ChangeStoreLink>
        }
      </StoreDetailsWrapper>
      <AddressWrapper>{ address }</AddressWrapper>
      <PhoneLink number={ formattedNumber } >
        <PhoneIcon asset="phone-blue" height={ 13 } width={ 13 } />
        {formattedNumber}
      </PhoneLink>
    </Media.Mobile>
  </Wrapper>

MyStoreBar.propTypes = {
  address: PropTypes.string,
  formattedNumber: PropTypes.string,
  nullState: PropTypes.bool,
  setShowStoreDetails: PropTypes.func,
  showStoreLocatorModalInAppointmentMode: PropTypes.func
}

export default MyStoreBar

const Circle = styled.div`
  position: relative;
  display: inline-block;
  bottom: 2px;
  background-color: ${Theme.colors.green};
  border-radius: 10px;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  ${Media.mobile`
    bottom: -1px;
    width: 15px;
    height: 15px;
  `}
  ${props => props.nullState && css`
    display: none;
  `}
`

const CheckIcon = styled(Icon)`
  position: relative;
  top: 2px;
  width: 21px;
  height: 11px;
  vertical-align: unset;
  ${Media.mobile`
    top: -1px;
    width: 15px;
    height: 9px;
  `}
`

const PhoneIcon = styled(Icon)`
  margin: 0 5px 0 0;
`

const MyStoreHeading = styled(Text)`
  text-transform: uppercase;
  color: ${Theme.colors.green};
  ${Mixin.font.GothamBold()}
  ${props => props.nullState && css`
    color: ${Theme.colors.black_new};
  `}
`

const StoreDetailsLink = styled(A)`
  border-right: 1px solid ${Theme.colors.light_grey};
  ${Mixin.responsive('padding-right', '10px', '5px')}
`

const ChangeStoreLink = styled(A)`
  ${Mixin.responsive('margin-left', '10px', '5px')}
  margin-left: 10px;
`

const Wrapper = styled.div`
  border: 1px solid #9d9d9d;
  ${Mixin.responsive('padding', '15px 40px', '15px 15px')}
`

const InnerWrapper = styled.div`
  display: inline-block;
`

const MyStoreHeadingWrapper = styled(InnerWrapper)`
  margin-right: 20px;
`

const StyledText = styled(Text)`
  ${Mixin.font.GothamBold()}
`

const AddressWrapper = styled(StyledText)`
  margin-right: 50px;
  font-weight: 600;
  ${Media.mobile`
    display: block;
    margin: 15px 0;
  `}
`

const StoreDetailsWrapper = styled(InnerWrapper)`
  ${Media.desktop`
    margin-left: 50px;
    ${props => props.nullState && css`
      margin: 0;
      float: right;
    `}
  `}
  ${Media.mobile`
    margin-top: 10px;
    ${props => props.nullState && css`
      margin: 0;
      float: right;
    `}
  `}
`
